import { createFileRoute } from '@tanstack/react-router';

import BreakingnewsContent from '../-components/BreakingnewsContent';

export const Route = createFileRoute('/_authenticated/breakingnews/$id/')({
    component: BreakingnewsContent,
});
